module.exports = __webpack_public_path__ + "img/bitcoin.7502eb49.png";